export default __webpack_public_path__ + "static/media/icons.821e74a2.svg";